var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"background-colour":_vm.status.background_colour,"text-colour":_vm.status.text_colour}},[_vm._v("\n    "+_vm._s(_vm.status.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }